import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from "../model/track-action-result";
import { BirthCountryInvestActionV2 } from './actions/birth-country-v2-action';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';

export class BasicPersonalTrackV2 extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('document-type', ['personal-data', 'document-type']),
    new TrackInfo('document-name', ['personal-data', 'document-name']),
    new TrackInfo('document-number', ['personal-data', 'document-number']),
    new TrackInfo('document-issuing', ['personal-data', 'document-issuing']),
    new TrackInfo('expedition-state', ['personal-data', 'expedition-state']),
    new TrackInfo('parentage', ['personal-data', 'parentage']),
    new TrackInfo('birth-country', ['personal-data', 'birth-country'], undefined, {
      undefined,
      actionName: ActionList.ActionStateBR
    }),
    new TrackInfo('birth-state', ['personal-data', 'birth-state']),
    new TrackInfo('birth-city', ['personal-data', 'birth-city']),
    new TrackInfo('nationality', ['personal-data', 'nationality']),
    new TrackInfo('gender', ['personal-data', 'gender']),
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.registration]})

  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_V2;
  }

  async loadData() {
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    return BirthCountryInvestActionV2.execute(data);
  }
  
  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionStateBR = 'actionStateBR',
}
